import React from 'react';
import { withFeatureSafe } from 'Common/ErrorBoundaries';
import Draggable from 'react-draggable';

const CustomDraggable = ({ handle, children, disableDraggable = true }) => {
    return (
        disableDraggable ? (
            <Draggable handle={handle} axis="both" bounds="html">
                <div    >
                    {children}
                </div>
            </Draggable>
        ) : (
            <div className="absolute">
                {children}
            </div>

        )
    );
};

export default withFeatureSafe(CustomDraggable);